<template>
  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 0">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 单选 -->
            <el-card v-for="(qu, idx1) in questionArray.t1" :key="idx1 + '1'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">{{ qu.i + 1 }}.单选</span></el-divider>
              </div>

              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="2" disabled v-model="qu.question.title"></textarea> 
              
              <b style="color: skyblue;">【</b> <b style="color: #409eff">{{ qu.flag
                }}</b> <b style="color: skyblue;">】</b>
              <div v-for="(ch, idx2) in qu.question.choiceList" :key="idx2 + '26'">
                <el-button :id="qu.id + ch.o" plain @click="singleChoice(qu, ch.o, idx1)">{{ ch.o }}.&nbsp;{{ ch.n }}
                </el-button>
              </div>
            </el-card>
            <!-- 多选 -->
            <el-card v-for="(qu, idx1) in questionArray.t2" :key="idx1 + '191'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">{{ qu.i + 1 }}.多选</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="2" disabled v-model="qu.question.title"></textarea> <b style="color: skyblue;">【</b> <b style="color: #409eff"
                v-for="(anr, idx2) in qu.flag" :key="idx2 + '842'">{{ anr }}</b> <b style="color: skyblue;">】</b>
              <div v-for="(ch, idx3) in qu.question.choiceList" :key="idx3 + '33'">
                <el-button plain :id="qu.id + ch.o" @click="moreChoice(qu, ch.o, idx1, idx3)"
                  :value="studentAnswer[qu.i][idx1]">{{ ch.o }}.&nbsp;{{ ch.n }}</el-button>
              </div>
            </el-card>
            <!-- 判断 -->
            <el-card v-for="(qu, idx1) in questionArray.t3" :key="idx1 + '121'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">{{ qu.i + 1 }}.判断</span></el-divider>
              </div>

              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}&nbsp;&nbsp;</b>
              <b>{{ qu.question.title }}</b> <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input v-model="studentAnswer[qu.i][idx1]" value="1" type="radio" :name="qu.id" />正确&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input v-model="studentAnswer[qu.i][idx1]" value="0" type="radio" :name="qu.id" />错误
            </el-card>
            <!-- 填空 -->
            <el-card v-for="(qu, idx1) in questionArray.t4" :key="idx1 + '8111'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">{{ qu.i + 1 }}.填空</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b>
              <span>
                <span v-for="(v, idx2) in qu.question.title" :key="idx2  + '2511'">{{ v }}
                  <input v-if="idx2 < qu.question.title.length - 1" type="text"
                    v-model="studentAnswer[qu.i][idx1][idx2]" />
                </span>
              </span>
              <br /><br />
            </el-card>
            <el-card v-for="(qu, idx1) in questionArray.t5" :key="idx1 + '2522'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">{{ qu.i + 1 }}.简答</span></el-divider>
              </div>

              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
              <textarea cols="100" rows="2" disabled v-model="qu.question.title"></textarea><br>

              <textarea cols="180" rows="4" v-model="studentAnswer[qu.i][idx1]"></textarea>
            </el-card>
            <el-card v-for="(qu, idx1) in questionArray.t6" :key="idx1 + '3343'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">{{ qu.i + 1 }}.论述</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="3" disabled v-model="qu.question.title"></textarea><br>
              <textarea cols="100%" rows="5" v-model="studentAnswer[qu.i][idx1]"></textarea>
            </el-card>
            <el-card v-for="(qu, idx1) in questionArray.t7" :key="idx1 + '4244'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">{{ qu.i + 1 }}.编程题</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="3" disabled v-model="qu.question.title"></textarea><br>
              <textarea cols="100" rows="20" v-model="studentAnswer[qu.i][idx1]"></textarea>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="16">
          <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">交 卷</el-button>
        </el-col>
        <el-col :span="5">
          <span style="color:#cc0000">考试还剩 {{ countDown }} </span>
        </el-col>
        <el-col :span="3">
          <span style="color:#0b7c0b"> {{ isCountShow }} </span>
        </el-col>
      </el-row>
    </div>
  </popup>
</template>
<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";

export default {
  components: {
    popup,
    FillInTheBlanks,
  },
  data() {
    return {
      anwsId: 1, //答案ID
      isMobile: 0,
      countDown: "",
      countDownCnt: 0,
      popupLoading: false,
      disabled: false,
      confirmLoading: false,
      parameter: {}, //exam
      isCountDownGo: 0,    //
      isCountShow: "",
      kid: "",
      stuid: "",
      formParameter: {},
      //题类型位置
      choice_question: { show: false },
      //题数组
      questionArray: { t1: [], t2: [], t3: [], t4: [], t5: [], t6: [], t7: [] },
      //学生答案对象
      studentAnswer: [],
      dateTimeSetInterval: function () { },
      //考试学生答案按时储存到本地缓存定时器
      storageStuAns: function () { },

      //客观题自动判卷用
      typeArrKG: [], //题型
      contentKG: [], //题目ID

      //主观题自动判卷用
      tkTypeArrKG: [], //题型
      tkContentKG: [], //主观题题目ID

      isReadStoreAnsr: false,  //初始考试读到缓存答案
      initStudentAnswerDone: false //初始答案OK-页面完成渲染
    };
  },

  methods: {
    //毫秒转时间
    formatDuring(mss) {
      var days = parseInt(mss / (1000 * 60 * 60 * 24));
      var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (mss % (1000 * 60)) / 1000;
      return (
        (hours < 10 ? "0" + hours : hours) +
        " 小时 " +
        (minutes < 10 ? "0" + minutes : minutes) +
        " 分钟 " +
        (Math.floor(seconds) < 10
          ? "0" + Math.floor(seconds)
          : Math.floor(seconds)) +
        " 秒 "
      );
    },

    //初始化学生答案对象
    initStudentAnswer(timeDown) {
      this.popupLoading = true
      this.isCountDownGo = 1;
      let questions = null

      /////尝试取回缓存的答案
      let localAnsr = this.$caches.answer.get()
      //取得有效的答案
      if (localAnsr && localAnsr.ansr && localAnsr.ansr.length > 0) {   //[]
         if(this.kid == localAnsr.kid ){
            this.studentAnswer = localAnsr.ansr;
            this.isReadStoreAnsr = true
            this.isCountShow ="已恢复缓存答题"
         }
      }
      /////尝试取回缓存的答案结束

      //取得试卷中的题目
      api.getexpContent({ exid: this.kid }, (response) => {
        //通过试卷 取回 题目
        questions = JSON.parse(response.data);

        //取得试卷中的题型
        let content = JSON.parse(questions.content);

        //取得本试卷的题型分布
        this.typeTxArr = content.types;
        this.typeTxArr.forEach((v, i) => {
          //根据题型 初始化答案
          let tcnt = content.qnums[i] * 1;
          let anws = [];
          if (v < 4) {
            //客观题
            this.typeArrKG.push(v);
            this.contentKG.push(content.contents[i]);

          } else {
            for (let idx = 0; idx < tcnt; idx++) {
              //默认值
              if (v == 4) {
                //填空题   避免//null[idx2]
                anws.push([]); //答案的数组是三维
              } else {
                anws.push(null);
              }
            }
            this.tkTypeArrKG.push(v);
            this.tkContentKG.push(content.contents[i]);
          }
          //初始化题型存储数组
          if ( !this.isReadStoreAnsr  ) {
            this.studentAnswer.push(anws);
          }
          this.questionArray[`t${v}`] = questions.contents[i].qid;
        });

        if (!this.isReadStoreAnsr) {
          //启动成功
          this.popupLoading = false
        }
        this.initStudentAnswerDone =true
      });


      //倒计时定时器
      let dateTime = timeDown;

      this.dateTimeSetInterval = setInterval(() => {

        dateTime = dateTime - 1000;
        if (dateTime < 0) {
          //超时强制提交
          this.strongclose();
        }

        this.countDown = this.formatDuring(dateTime);
        this.countDownCnt++

        //定时每30秒在本地缓存储存学生答案
        if (this.countDownCnt % 30 == 0) {
          if (dateTime > 0) {
            if(this.studentAnswer.length>0){
               this.isCountShow = "已缓存至" + new Date().format("hh:mm:ss")
               this.$caches.answer.set(  {kid:this.kid, ansr : this.studentAnswer}  );
            }
          }
        }
      }, 1000);

      //如果需要还原缓存答案，延迟n秒
      if (this.isReadStoreAnsr) {

        let tryRestoreAnsr = setInterval(() => {
          //如果异步的页面加载结束
          if (this.initStudentAnswerDone) {

            //还原 选择题  答案       文本的答案 v-model 自动搞定  []==>{}
                              //  1 , 0
                              //  2 , 0/1
            this.typeTxArr.forEach((v, i) => {
              if (v < 3) {//选择题

                if (v == 1) { //还原   单选题
                  let danxuan = this.studentAnswer[0];
                  for (let ans = 0; ans < danxuan.length; ans++) {
                    let oneAnsr = danxuan[ans];
                    //singleChoice(题目, 选择的[A、B、C..], 单选分类的题号)
                    //有缓存答案：已做过的
                    if (oneAnsr) {
                      this.singleChoice(questions.contents[0].qid[ans], oneAnsr, ans);
                    }
                  }
                } else if (v == 2) { //还原   多选题
                  let duoxuanQues
                  let duoxuanAnsrs
                  if (i == 0) {  //没有单选
                    duoxuanQues = questions.contents[0]       //  [[单选..],[多选],[简答]]   
                    duoxuanAnsrs = this.studentAnswer[0];     //  [[单选..],[多选],[简答]]
                  } else {
                    duoxuanQues = questions.contents[1]
                    duoxuanAnsrs = this.studentAnswer[1];
                  }

                  for (let ans = 0; ans < duoxuanAnsrs.length; ans++) {
                    let oneAnsr = duoxuanAnsrs[ans];
                    //有做 notnull     ""         
                    if (oneAnsr && oneAnsr.length > 0) {
                       //把类似ACD的答案切成 A、C、D执行三次
                      for (let idx = 0; idx < oneAnsr.length; idx++) {
                        const ansr = oneAnsr[idx];
                        //  A 答案是 0 ，B答案是1
                        let idx3 = ansr.charCodeAt(0) - 65
                         //moreChoice(题目, 选择的[A/C/D..], 单选分类的题号, 本次点击的备选答案序号)
                        this.moreChoice(duoxuanQues.qid[ans], ansr, ans, idx3);
                      }
                    }
                  }
                }

              }
            });
            this.popupLoading = false
            //console.log("RestoreAnsr成功,把自己停了")
            clearInterval(tryRestoreAnsr);
          }
          //console.log("RestoreAnsr...")
        }, 1000);

      }

    },
    //单选赋值
    singleChoice(qu, choice, idx) {
      // 获取当前按钮
      const currentButton = document.getElementById(qu.id + choice);
      // 当前按钮的父亲DIV的兄弟们
      const btnParentBrother = currentButton.parentNode.parentNode.children;
      // 循环消除其他按钮颜色
      for (
        let i = btnParentBrother.length - 1;
        i > btnParentBrother.length - 5;
        i--
      ) {
        btnParentBrother[i].firstChild.style.backgroundColor = "white";
      }
      // 给当前按钮加背景色
      currentButton.style.backgroundColor = "skyblue";
      //前端存储
      this.studentAnswer[qu.i][idx] = choice;
      //页面回显
      qu.flag = choice;
    },
    //获取填空题的答案数组,并且绑定到studentAnswer.answer上
    getAnswerArr(answerArr, i) {
      this.studentAnswer[i.i][i.j] = answerArr;
    },

    //多选赋值
    moreChoice(question, choice, idx1, idx3) {
      if (question.flag) {
        if (question.flag[idx3] == choice) {
          //question.flag.[idx3]=""  forceUpdate()      vue2的虚拟机vm双向绑定bug
          this.$set(question.flag, idx3, "");
        } else {
          this.$set(question.flag, idx3, choice);
        }
      } else {
        this.$set(question, "flag", []);
        this.$set(question.flag, idx3, choice);
      }
      this.studentAnswer[question.i][idx1] = question.flag.join("");
      // 获取当前按钮
      //console.log("idx3", idx3)
      //console.log("currentClass", question.id + choice)
      const currentClass = document.getElementById(question.id + choice);
      // 给当前按钮加背景色
      if (currentClass.style.backgroundColor == "skyblue") {
        currentClass.style.backgroundColor = "white";
      } else {
        currentClass.style.backgroundColor = "skyblue";
      }
    },
    //打开弹框
    open(row, timeDown, awrid, title, disabled) {
      //reset
      this.typeArrKG = []; //题型
      this.contentKG = []; //题目ID
      this.tkTypeArrKG = []; //填空题型
      this.tkContentKG = []; //填空题题目ID
      this.studentAnswer = [];
      this.questionArray = {
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t6: [],
        t7: [],
      };

      this.isMobile = row.isMobile;
      this.canScore = row.canScore;
      this.kid = row.id;
      this.anwsId = awrid;
      let me = this.$caches.user.get();
      this.stuid = me.id;
      //根据考试id取回试卷
      api.findPaperByKid({ kid: this.kid }, (res) => {
        //考试
        this.parameter = res.data.exm;

        //试卷ID
        this.expId = this.parameter.expid;


        if (this.isCountDownGo == 0) {
          //加载答案
          this.initStudentAnswer(timeDown);
        }

        this.$refs.popup.open(title, "100%");

        this.disabled = disabled;
      });
    },
    strongclose() {
      clearInterval(this.dateTimeSetInterval);
      clearInterval(this.storageStuAns);
      let parameter = {
        kid: this.kid,
        sid: this.stuid,
        answer: JSON.stringify(this.studentAnswer),
      };
      //强制交卷
      api.updateAnswers(parameter, (response) => { });

      this.clear();
    },

    close() {
      this.clear();
    },
    clear() {

      this.disabled = false;
      this.isCountShow = ""
      this.isReadStoreAnsr = false
      this.initStudentAnswerDone = false

      this.$refs.popup.closeCallback();
      //退出初始化参数

      clearInterval(this.dateTimeSetInterval);
      clearInterval(this.storageStuAns);
      this.countDown = "";
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.parameter = {};
      this.isCountDownGo = 0;
      this.formParameter = {};
      // this.studentAnswer = [];
      this.choice_question = { show: false };
      this.questionArray = {
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t6: [],
        t7: [],
      };
      this.$emit("closeExam");
    },
    confirm() {
      //停止考试倒计时
      clearInterval(this.dateTimeSetInterval);
      clearInterval(this.storageStuAns);

      let types = null;
      let qids = null;
      let tkTypes = null;
      let tkQids = null;
      if (this.typeArrKG.length > 0) {
        //存在客观题
        types = JSON.stringify(this.typeArrKG);
        qids = JSON.stringify(this.contentKG);
      }
      if (this.tkTypeArrKG.length > 0) {
        //存主观题
        tkTypes = JSON.stringify(this.tkTypeArrKG);
        tkQids = JSON.stringify(this.tkContentKG);
      }

      this.$confirm("您确定要结束考试并提交试卷么?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //清除本地缓存学生答案
          this.$caches.answer.remove()

          let parameter = {
            id: this.anwsId,
            kid: this.kid,
            sid: this.stuid,
            expid: this.expId,

            canScore: this.canScore, //实际传递  多选是否可以得分
            types: types, //实际传递 客观题类型数组
            qids: qids, //实际传递 客观题题号

            tkTypes: tkTypes, //实际传递 填空题题类型数组
            tkQids: tkQids, //实际传递 填空题题题号

            isMobile: this.isMobile ? this.isMobile : 0,

            answer: JSON.stringify(this.studentAnswer),
          };
          //
          console.log("交卷的内容：", parameter); //后端提交后校验    未作答的null  一般发生在后面
          api.updateAnswers(parameter, (res) => {
            this.$parent.list();
            this.clear();
            this.close();
          });
        })
        .catch(() => {
          this.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-card,
input[type="radio"],
textarea,
/deep/ .el-button {
  margin-top: 10px;
}

textarea {
  padding: 10px 5px;
}
</style>
